import { create } from "zustand";
import { SensorUnitsService } from "../services/sensorUnits.service";

export const useSensorsStore = create((set, get) => ({
  sensors: [],
  loading: false,
  error: null,

  fetchSensors: async () => {
    set({ loading: true });
    try {
      const data = await SensorUnitsService.getAll();
      set({ sensors: data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createSensor: async (payload) => {
    try {
      const data = await SensorUnitsService.create(payload);
      set((s) => ({ sensors: [...s.sensors, data] }));
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  },

  updateSensor: async (id, payload) => {
    try {
      const data = await SensorUnitsService.update(id, payload);
      set((s) => ({
        sensors: s.sensors.map((x) => (x.id === id ? data : x)),
      }));
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  },

  deleteSensor: async (id) => {
    if (!window.confirm("Are you sure you want to delete this sensor?")) return;
    try {
      await SensorUnitsService.delete(id);
      set((s) => ({ sensors: s.sensors.filter((x) => x.id !== id) }));
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  },
}));
